import CryptoJS from 'crypto-js'
//import crypto from 'node:crypto'
import {generateHexKey} from '@/utils/generateHexKey'

const randomKey=generateHexKey(32);
const randomIV=generateHexKey(16)
//const randomKey=crypto.randomBytes(32).toString('hex');
//const randomIV=crypto.randomBytes(16).toString('hex');

const SECRET_KEY=CryptoJS.enc.Hex.parse(randomKey)
const IV=CryptoJS.enc.Hex.parse(randomIV)

export function aesEncrypt(word){
	const src=CryptoJS.enc.Utf8.parse(word)
	const encrypted=CryptoJS.AES.encrypt(src,SECRET_KEY,{
		iv: IV,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.Pkcs7
	})
	return encrypted.toString()
}

export function aesDecrypt(word){
	const decrypt=CryptoJS.AES.decrypt(word,SECRET_KEY,{
		iv: IV,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.Pkcs7
	})
	return decrypt.toString(CryptoJS.enc.Utf8)
}